import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  customerCountryFromModel,
  validateCustomerCountryCondition,
  type CustomerCountryState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const CUSTOMER_COUNTRY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<CustomerCountryState>>,
): ConditionType<CustomerCountryState, Condition.CustomerCountry> => ({
  name: "Customer country",
  description(state) {
    return `Countries: ${state.length} selected`;
  },
  Details(props: ConditionTypeDetailsProps<CustomerCountryState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return customerCountryFromModel(model);
  },
  toModel(state) {
    return { type: Condition.CUSTOMER_COUNTRY, countries: state };
  },
  valid(state) {
    return validateCustomerCountryCondition(state).valid;
  },
});

export { type CustomerCountryState } from "@redotech/redo-model/return-flow/condition-validate";
